import { useQuery } from "@tanstack/react-query";
import { getBundlesGrouped } from "../services/get-bundles-grouped";
import { useRegionFilter } from "@/features/regions/hooks/use-region-filter";
import { ALL_REGIONS_CODE } from "@/features/regions/constants";
import { GroupedBundlesResponse } from "@/pages/bundles/types/grouped-bundle";

// Grouped bundles for the active region. `region` overrides the URL region for
// the few screens that carry their own region selector (the Pricing Catalog
// tool); pass ALL_REGIONS_CODE for no region filter. Omit it and the global URL
// region applies, as everywhere else. `enabled` lets such a screen hold the
// query until its selector has a value — without it an empty selection would
// read as "all regions" and fetch every region's bundles.
export default function useBundlesGrouped({
  q,
  region: regionOverride,
  enabled = true,
}: {
  q?: string;
  region?: string;
  enabled?: boolean;
}) {
  const urlRegion = useRegionFilter();
  const region =
    regionOverride === undefined
      ? urlRegion
      : regionOverride === ALL_REGIONS_CODE || !regionOverride
        ? undefined
        : regionOverride;

  return useQuery<GroupedBundlesResponse>({
    queryKey: ["bundles", "grouped", { region, q }],
    queryFn: () => getBundlesGrouped({ region, q }),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
    enabled,
  });
}
